import React from 'react';
import classNames from 'classnames';
import FontAwesomeIcon from 'src/components/Icon';
import Input from 'src/components/Input';
import { OTHER_SLOT_LABEL } from './timeSlotOptions';

interface DaySlotPickerProps {
  days: string[];
  slots: string[];
  tab: string;
  otherSelected: boolean;
  otherValue: string | null;
  isSlotSelected: (slotLabel: string) => boolean;
  onDaySelect: (day: string) => void;
  onSlotToggle: (slotLabel: string) => void;
  onOtherToggle: () => void;
  onOtherValueChange: (value: string) => void;
}

const DaySlotPicker = ({
  days,
  slots,
  tab,
  otherSelected,
  otherValue,
  isSlotSelected,
  onDaySelect,
  onSlotToggle,
  onOtherToggle,
  onOtherValueChange,
}: DaySlotPickerProps) => {
  const isOtherSlot = (slot: string): boolean => slot === OTHER_SLOT_LABEL;

  const slotIsActive = (slot: string): boolean => {
    if (isOtherSlot(slot)) {
      return otherSelected;
    }

    return isSlotSelected(slot);
  };

  const onSlotClick = (slot: string) => {
    if (isOtherSlot(slot)) {
      onOtherToggle();

      return;
    }

    onSlotToggle(slot);
  };

  return (
    <>
      <div className="slot-tabs">
        {days.map((day: string) => (
          <button
            type="button"
            key={day}
            onClick={() => onDaySelect(day)}
            className={classNames('slot-tab', {
              'is-active': day === tab,
            })}
          >
            {day}
          </button>
        ))}
      </div>
      <div className="slot-list">
        {slots.map((slot: string) => (
          <button
            type="button"
            key={`${tab} ${slot}`}
            onClick={() => onSlotClick(slot)}
            className={classNames('slot-option', {
              'is-active': slotIsActive(slot),
              'is-other': isOtherSlot(slot),
            })}
          >
            <div className="slot-bullet">
              <FontAwesomeIcon glyph="check" weight="regular" />
            </div>
            {slot}
            {isOtherSlot(slot) && (
              <div className="slot-other-input">
                &nbsp;&nbsp;{' '}
                <Input
                  value={otherValue}
                  onChange={(event: any) =>
                    onOtherValueChange(event?.target?.value)
                  }
                  label={null}
                />
              </div>
            )}
          </button>
        ))}
      </div>
    </>
  );
};

export default DaySlotPicker;